import { Box, CircularProgress, Fade, styled } from '@mui/material';

type SmallLoaderProps = {
  show?: boolean;
};

export function SmallLoader({ show }: SmallLoaderProps) {
  return (
    <Fade in={show ?? true}>
      <LoaderWrapper data-testid="loader" borderRadius={24}>
        <CircularProgress size={48} />
      </LoaderWrapper>
    </Fade>
  );
}

const LoaderWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
}));
